import Styles from './Card.module.css';

const Card=(props)=>{
    return (
     <div className={props.type==='header' ? Styles.cardHeader : Styles.card}>{props.children}</div>   
    )
}
export default Card;